<div class="tab-pane engine__tab-pane fade show active" id="car-rental" role="tabpanel" aria-labelledby="car-rental-tab">
  <form class="search-form" name="car-rental" #form="ngForm">
    <div class="search-form__engine search-form__engine--two-rows">
      <div class="search-form__row">
        <div class="search-form__select search-form__select--flex search-form__element">
          <div class="form-group-custom">
            <label for="inputWhereRental" class="input-group-zeus__label">Dove</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="inputWhereParking-select">
              <ng-select [items]="locations$ | async" [typeahead]="locationQuery$"
                         placeholder="Localita' di ritiro"
                         name="location"
                         required
                         [loading]="isLoading" [(ngModel)]="selectedLocation"
                         [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri"
                         id = "inputWhereRental"
                         class="form-control-custom">
                <ng-template ng-label-tmp let-item="item">
                  <span>{{getCarItemName(item) | stripTags}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span [innerHTML]="getCarItemName(item)"></span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon1"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__select--flex search-form__element">
          <div class="form-group-custom">
            <label for="inputAgeRental" class="input-group-zeus__label">Età guidatore</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="inputAgeRental-select">
              <ng-select [(ngModel)]="selectedAge" [items]="ages"
                         name="age"
                         required
                         id = "inputAgeRental"
                         class="form-control-custom">
                <ng-template ng-header-tmp>
                  <span>Eta' guidatore...</span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <span>{{getAgeString(item) | stripTags}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span [innerHTML]="getAgeString(item)"></span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon2"><i class="icon-user"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-form__row">
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="rentalReturn-input" class="input-group-zeus__label">Ritiro</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="rentalReturn-input">
              <input readonly [(ngModel)]="selectedCheckinDate"
                     type="text"
                     name="checkin"
                     required
                     placeholder="Ritiro"
                     ngbDatepicker #dpA="ngbDatepicker" (click)="dpA.toggle()"
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon3"><i class="icon-date"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__hour search-form__element">
          <div class="form-group-custom">
            <label for="rentalWithdrawalHour" class="input-group-zeus__label">Orario</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="rentalWithdrawalHour-select">
              <ng-select [(ngModel)]="selectedCheckinTime" [items]="times"
                         id = "rentalWithdrawalHour"
                         name="checkinTime"
                         required
                         class="form-control-custom">
                <ng-template ng-header-tmp>
                  <span>Orario Ritiro...</span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <span>{{getTimeItemName(item) | stripTags}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span [innerHTML]="getTimeItemName(item)"></span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon4"><i class="icon-clock"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="rentalReturn-input" class="input-group-zeus__label">Riconsegna</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="rentalReturn-input">
              <input readonly [(ngModel)]="selectedCheckoutDate"
                     type="text"
                     name="checkout"
                     required
                     placeholder="Riconsegna"
                     ngbDatepicker #dpR="ngbDatepicker" (click)="dpR.toggle()"
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon5"><i class="icon-date"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__hour search-form__element">
          <div class="form-group-custom">
            <label for="rentalReturnHour" class="input-group-zeus__label">Orario</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="rentalReturnHour-select">
              <ng-select [(ngModel)]="selectedCheckoutTime" [items]="times"
                         id = "rentalReturnHour"
                         name="checkoutTime"
                         required
                         class="form-control-custom">
                <ng-template ng-header-tmp>
                  <span>Orario Riconsegna...</span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <span>{{getTimeItemName(item) | stripTags}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span [innerHTML]="getTimeItemName(item)"></span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon6"><i class="icon-clock"></i></span>
              </div>
            </div>
          </div>
        </div>
        <button [disabled]="form.invalid" (click)="doSearch()"
                class="search-form__cta search-form__element btn btn--sm btn--brand-color-03 btn__uppercase mt-3">Cerca <i class="icon-search"></i></button>
      </div>
    </div>
  </form>
</div>

<!--
<ng-select [items]="locations$ | async" [typeahead]="locationQuery$"
           placeholder="Localita' di ritiro"
           [loading]="isLoading" [(ngModel)]="selectedLocation"
           [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri">
  <ng-template ng-label-tmp let-item="item">
    <span>{{getCarItemName(item) | stripTags}}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span [innerHTML]="getCarItemName(item)"></span>
  </ng-template>
</ng-select>

<ng-select [(ngModel)]="selectedAge" [items]="ages">
  <ng-template ng-header-tmp>
    <span>Eta' guidatore...</span>
  </ng-template>
  <ng-template ng-label-tmp let-item="item">
    <span>{{getAgeString(item) | stripTags}}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span [innerHTML]="getAgeString(item)"></span>
  </ng-template>
</ng-select>

<input readonly [(ngModel)]="selectedCheckinDate" type="text" placeholder="Ritiro" ngbDatepicker #dpA="ngbDatepicker" (click)="dpA.toggle()">

<ng-select [(ngModel)]="selectedCheckinTime" [items]="times">
  <ng-template ng-header-tmp>
    <span>Orario Ritiro...</span>
  </ng-template>
  <ng-template ng-label-tmp let-item="item">
    <span>{{getTimeItemName(item) | stripTags}}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span [innerHTML]="getTimeItemName(item)"></span>
  </ng-template>
</ng-select>

<input readonly [(ngModel)]="selectedCheckoutDate" type="text" placeholder="Riconsegna" ngbDatepicker #dpR="ngbDatepicker" (click)="dpR.toggle()">

<ng-select [(ngModel)]="selectedCheckoutTime" [items]="times">
  <ng-template ng-header-tmp>
    <span>Orario Riconsegna...</span>
  </ng-template>
  <ng-template ng-label-tmp let-item="item">
    <span>{{getTimeItemName(item) | stripTags}}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span [innerHTML]="getTimeItemName(item)"></span>
  </ng-template>
</ng-select>

<button [disabled]="!canSearch()" (click)="doSearch()" class="btn btn-info">Cerca</button>
-->
